export default __webpack_public_path__ + "static/media/African.bea40417.png";